import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createDriverExpense,
  deleteDriverExpense,
  getDriverExpenseById,
  getDriverExpenses,
  updateDriverExpense,
} from "./driver-expenses.service";

export const useGetDriverExpenses = () => {
  return useQuery({
    queryKey: ["driver-expenses"],
    queryFn: getDriverExpenses,
  });
};

export const useGetDriverExpenseById = (driverExpenseId) => {
  return useQuery({
    queryKey: ["driver-expenses", driverExpenseId],
    queryFn: () => getDriverExpenseById(driverExpenseId),
    enabled: Boolean(driverExpenseId),
  });
};

export const useCreateDriverExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createDriverExpense,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["driver-expenses"] });
    },
  });
};

export const useUpdateDriverExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ driverExpenseId, driverExpenseData }) =>
      updateDriverExpense(driverExpenseId, driverExpenseData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["driver-expenses"] });
    },
  });
};

export const useDeleteDriverExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteDriverExpense,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["driver-expenses"] });
    },
  });
};
